import PropTypes from "prop-types";
import { isFunction } from "lodash";
import { t } from "@/i18n-js/instance";
import { Dropdown } from "@circle-react-uikit/Dropdown";

export const BookmarkManageOptions = ({
  onCreateLinkClick,
  onEditFolderClick,
  onDeleteClick,
}) => (
  <>
    <Dropdown.Separator />
    <Dropdown.ItemLink
      onClick={() => {
        isFunction(onCreateLinkClick) && onCreateLinkClick();
      }}
    >
      {t("spaces.bookmarks.create_link")}
    </Dropdown.ItemLink>
    <Dropdown.ItemLink
      onClick={() => {
        isFunction(onEditFolderClick) && onEditFolderClick();
      }}
    >
      {t("spaces.bookmarks.edit_folder")}
    </Dropdown.ItemLink>
    <Dropdown.ItemWithLink
      hasDanger
      onClick={() => {
        isFunction(onDeleteClick) && onDeleteClick();
      }}
    >
      {t("delete")}
    </Dropdown.ItemWithLink>
  </>
);

BookmarkManageOptions.propTypes = {
  onCreateLinkClick: PropTypes.func,
  onEditFolderClick: PropTypes.func,
  onDeleteClick: PropTypes.func,
};
